<template>
  <div
    class="notification"
    :class="[isUnread && 'notification--unread']"
  >
    <component
      :is="isAdmin ? 'span' : 'a'"
      class="notification__name"
      @click="$emit('read')"
    >
      {{ title }}
    </component>
    <span class="notification__date">{{ date }}</span>
    <span
      v-if="!isAdmin"
      class="notification__actions"
    >
      <v-button
        color="transparent"
        @click="$emit('read')"
      >
        <v-icon type="show" />
      </v-button>
      <v-button
        color="transparent"
        @click="$emit('delete')"
      >
        <v-icon type="trash" />
      </v-button>
    </span>
    <span class="notification__category">
      <v-badge
        class="notification__badge"
        :text="type"
      />
    </span>
    <div
      v-if="isAdmin"
      class="notification__admin"
    >
      <p
        v-if="body"
        class="notification__body"
      >
        {{ body }}
      </p>
      <div
        v-if="recipient"
        class="notification__meta"
      >
        <strong>Recipients:</strong>
        {{ recipient }}
      </div>
      <div
        v-if="sender"
        class="notification__meta"
      >
        <strong>Sender:</strong>
        {{ sender }}
      </div>
      <div
        v-if="reminders"
        class="notification__meta"
      >
        <div
          v-for="(rem, index) in reminders"
          :key="`res_${index}`"
        >
          <strong>Sent On:</strong>
          {{ rem.sent_on }}

          <strong style="margin-left:20px;">Sent To:</strong>
          {{ `${rem.sent_to.length} TAs.` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Badge from '@/atoms/Badge';
  import Button from '@/atoms/Button';
  import Icon from '@/atoms/Icon';

  export default {
    components: {
      "v-button": Button,
      "v-badge": Badge,
      "v-icon": Icon
    },
    props: {
      title: {
        type: String,
        default: null
      },
      body: {
        type: String,
        default: null
      },
      date: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: null
      },
      recipient: {
        type: String,
        default: null
      },
      sender: {
        type: String,
        default: null
      },
      isUnread: {
        type: Boolean,
        default: false
      },
      isAdmin: {
        type: Boolean,
        default: false
      },
      reminders: {
        type: Array,
        default: () => []
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .notification {
    $this: &;
    display: flex;
    padding: 5px;
    flex-wrap: wrap;
    align-items: center;
    border-top: solid 1px $zircon;
    &:last-child {
      border-bottom: solid 1px $zircon;
    }
    &__name {
      color: inherit;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      @at-root {
        a#{&} {
          cursor: pointer;
        }
      }
    }
    &__category {
      width: 100%;
      @include minpoint(tablet) {
        width: auto;
        margin-left: .5em;
        margin-right: .5em;
      }
    }
    &__badge {
      min-width: 5rem;
    }
    &__date {
      display: none;
      margin-left: .5em;
      margin-right: .5em;
      @include minpoint(tablet) {
        order: 1;
        display: block;
      }
    }
    &__actions {
      @include minpoint(tablet) {
        order: 2;
      }
    }
    &__admin {
      order: 3;
      width: 100%;
    }
    &__body {
      font-size: $font-size-sm;
      margin-bottom: .5rem;
    }
    &--unread {
      background-color: $zircon;
      #{$this}__name {
        font-weight: bold;
      }
    }
  }
</style>
